module.exports = __webpack_public_path__ + "static/media/premium_question_icon.4bf240ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question_bank/premium_question_icon.svg
// module id = 1042
// module chunks = 0